



















import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';

@Component({
  components: {
    MainButton,
  },
})
export default class AddButton extends Vue {
  @Prop({
    required: false,
    default: false,
  })
  addModeValue!: boolean;

  @Emit('clickButton')
  clickButton(): void {}

  get addMode(): any {
    return {
      color: this.addModeValue ? 'gray' : 'bluePrimary',
      text: this.addModeValue ? 'Adicionando' : 'Adicionar',
      class: this.addModeValue ? 'add-mode' : 'default-mode',
      icon: !this.addModeValue,
    }
  }
}
